import { nsRentalFile } from '@/app/i18n/namespaces';

const RENTAL_EVENT_TYPES = {
    PREAUTHORIZATION: {
        name: 'PREAUTHORIZATION',
        entity: 'event_type.PREAUTHORIZATION',
        namespace: nsRentalFile,
        variant: 'gray'
    },
    PREAUTHORIZATION_CANCELLATION: {
        name: 'PREAUTHORIZATION_CANCELLATION',
        entity: 'event_type.PREAUTHORIZATION_CANCELLATION',
        namespace: nsRentalFile,
        variant: 'blue'
    },
    DOCUMENT_REQUEST: {
        name: 'DOCUMENT_REQUEST',
        entity: 'event_type.DOCUMENT_REQUEST',
        namespace: nsRentalFile,
        variant: 'gray'
    },
    ADDITIONAL_INVOICE: {
        name: 'ADDITIONAL_INVOICE',
        entity: 'event_type.ADDITIONAL_INVOICE',
        namespace: nsRentalFile,
        variant: 'gray'
    },
    PAYMENT: {
        name: 'PAYMENT',
        entity: 'event_type.PAYMENT',
        namespace: nsRentalFile,
        variant: 'gray'
    },
    REMOTE_COLLECTION: {
        name: 'REMOTE_COLLECTION',
        entity: 'event_type.REMOTE_COLLECTION',
        namespace: nsRentalFile,
        variant: 'green'
    },
    UNKNOWN: {
        name: 'UNKNOWN',
        entity: 'event_type.UNKNOWN',
        namespace: nsRentalFile,
        variant: 'gray'
    }
};

export default RENTAL_EVENT_TYPES;